import React from 'react';
import { Inbox, Plus, Lock } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { StatusPill, EmptyState, PageHeader, MemberAvatar, Price, DateLabel } from '@/components/design';
import { STATUSES } from '@/utils/statusLabels';

const DOMAINES = {
  mission: 'Missions',
  proposition: 'Propositions',
  paiement: 'Paiements',
  versement: 'Versements',
  annonce: 'Colis et trajets',
  identite: "Pièce d'identité",
};

const COULEURS = [
  ['--c-marine', 'Marine nuit'], ['--c-encre', 'Encre'], ['--c-safran', 'Safran'], ['--c-vert', 'Vert'],
  ['--c-brique', 'Brique'], ['--c-brume', 'Brume'], ['--c-safran-clair', 'Safran clair'], ['--c-trait', 'Trait'],
];

const titre = { fontFamily: 'var(--c-police-titre)', fontSize: 22, fontWeight: 800, margin: '32px 0 14px', color: 'var(--c-encre)' };

/** Page interne (admin) : tous les composants du système de design, pour vérifier leur rendu. */
export default function AdminDesign() {
  return (
    <div style={{ padding: '24px 28px 64px', fontFamily: 'var(--c-police-texte)', color: 'var(--c-encre)' }} data-testid="admin-design">
      <PageHeader
        title="Système de design"
        subtitle="Direction C « Lien » — composants partagés (components/design) et jetons (styles/design-tokens.css)"
        actions={<Button>Action principale</Button>}
      />

      <h2 style={titre}>Couleurs</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {COULEURS.map(([v, nom]) => (
          <div key={v} style={{ width: 120 }}>
            <div style={{ height: 64, borderRadius: 'var(--c-rayon-l)', background: `var(${v})`, border: '1px solid var(--c-trait)' }} />
            <div style={{ fontSize: 13, fontWeight: 700, marginTop: 6 }}>{nom}</div>
            <code style={{ fontSize: 12, color: 'var(--c-texte-3)' }}>{v}</code>
          </div>
        ))}
      </div>

      <h2 style={titre}>Boutons</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
        <Button><Plus />Publier un colis</Button>
        <Button variant="payment"><Lock />Réserver 45,00 €</Button>
        <Button variant="outline">Écrire</Button>
        <Button variant="link">Plus tard</Button>
        <Button variant="destructive">Annuler la réservation</Button>
      </div>

      <h2 style={titre}>Statuts</h2>
      {Object.entries(DOMAINES).map(([domaine, nom]) => (
        <div key={domaine} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 8, marginBottom: 12 }}>
          <span style={{ width: 150, fontSize: 14, fontWeight: 700 }}>{nom}</span>
          {Object.keys(STATUSES[domaine]).map((code) => <StatusPill key={code} domain={domaine} code={code} />)}
        </div>
      ))}

      <h2 style={titre}>Membres, montants, dates</h2>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, alignItems: 'center' }}>
        <MemberAvatar firstName="Marie" lastName="Diop" />
        <MemberAvatar firstName="Amadou" lastName="Traoré" />
        <MemberAvatar firstName="Koumba" lastName="Sow" size={56} />
        <Price amount={1250.5} currency="EUR" />
        <Price amount={22000} currency="XOF" />
        <Price amount={8.5} currency="EUR" unit="/ kg" />
        <DateLabel value="2026-11-12" />
      </div>

      <h2 style={titre}>État vide</h2>
      <div style={{ border: '1px dashed var(--c-trait-2)', borderRadius: 'var(--c-rayon-l)' }}>
        <EmptyState icon={Inbox} title="Aucune proposition reçue" action={<Button variant="outline">Voir les annonces</Button>}>
          Quand un membre vous proposera un transport ou un colis, il apparaîtra ici.
        </EmptyState>
      </div>
    </div>
  );
}
